import { ThemeProvider } from '@mui/system';
import { DataContext } from '@context/DataContext';
import InvestigationProvider from './Context/InvestigationContext';
import LoadingComponent from './Components/Loading';
import { BrowserRouter } from 'react-router-dom';
import AppRoutes from './Routes/AppRoutes';
import { LocalizationProvider } from '@context/LocalizationContext';
import { getThemeFromConfig } from './Theming/applicationTheme';
import { LoadingProvider } from '@context/LoadingContext';
import { ErrorBoundary } from './Config/bugsnag';
import { LocalizationProvider as MuiLocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { enUS } from 'date-fns/locale';

const queryParams = new URLSearchParams(window.location.search);

function App() {
	const applicationTheme: any = getThemeFromConfig();
	return (
		<ErrorBoundary>
			<ThemeProvider theme={applicationTheme}>
				<LocalizationProvider>
					<MuiLocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={enUS}>
						<div
							id={'myApp'}
							style={{ backgroundColor: applicationTheme.palette.appBackground }}
							className="App">
							<header className="App-header">
								<BrowserRouter>
									<DataContext.Provider
										value={{
											sc: queryParams.get('sc') ?? '',
										}}>
										<InvestigationProvider>
											<LoadingProvider>
												<>
													<LoadingComponent />
													<AppRoutes />
												</>
											</LoadingProvider>
										</InvestigationProvider>
									</DataContext.Provider>
								</BrowserRouter>
							</header>
						</div>
					</MuiLocalizationProvider>
				</LocalizationProvider>
			</ThemeProvider>
		</ErrorBoundary>
	);
}

export default App;
